<script>
import moment from "moment-timezone";
export default {
  name: "SpecialTutorDetail",
  props:{
    task:{
      type: Object,
      default: () => {}
    }
  },
  methods:{
    formatDate(date){
      if(!date) return '';
      return moment(date).format('DD/MM/YYYY');
    }
  }
}
</script>

<template>
  <div class="col-md-12 px-6">
    <div
        style="border:1px solid #D6D5D5; border-radius: 5px; background-color: #F6F6F6"
        class="px-3 py-5 w-100 row"
    >
      <div class="col-md-6 mb-4">
        <p>Mã tác vụ</p>
        <el-input placeholder="-" :value="task?.id"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Phân loại</p>
        <el-input placeholder="Gia sư đặc biệt" :value="task?.subtype_label"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Nội dung gia sư</p>
        <el-input placeholder="-" :value="task?.detail?.content"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Ngân sách phòng ban</p>
        <el-input placeholder="-" :value="task?.detail?.budget_amount_department_name"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Ngày làm</p>
        <el-input placeholder="-" :value="formatDate(task?.detail?.date)"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Thời gian bắt đầu</p>
        <el-input placeholder="-" :value="task?.detail?.start_time"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Thời gian kết thúc</p>
        <el-input placeholder="-" :value="task?.detail?.end_time"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Chi nhánh học</p>
        <el-input placeholder="-" :value="task?.branch_name"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Trình độ học</p>
        <el-input placeholder="-" :value="task?.level_out_name"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Họ và tên khách hàng</p>
        <div style="position: relative">
          <el-input placeholder="-" :value="task?.user_name"></el-input>
          <router-link :to="`/customer-crm/detail/${task?.user_id}?best_customer_id=${task?.best_customer_id}&active_name=cskh`" target="_blank" class="watch-detail" >Xem chi tiết</router-link>
        </div>
      </div>

      <div class="col-md-6 mb-4">
        <p>Số điện thoại khách hàng</p>
        <el-input placeholder="-" :value="task?.user_phone"></el-input>
      </div>
    </div>
  </div>

</template>

<style scoped>
.watch-detail{
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #0066FF;
  cursor: pointer;
  font-weight: 600;
}

</style>